import React from 'react';
import { Box, Typography } from '@mui/joy';

const ReportMobileRowList = ({ columns, rows = [], emptyMessage, getRowKey }) => {
  const gridTemplate = columns.map((col) => col.width || '1fr').join(' ');

  if (rows.length === 0) {
    return (
      <Typography level="body-sm" sx={{ opacity: 0.7, py: 2, textAlign: 'center' }}>
        {emptyMessage}
      </Typography>
    );
  }

  const rowSx = {
    display: 'grid',
    gridTemplateColumns: gridTemplate,
    gap: 0.5,
    alignItems: 'center',
    px: 0.5,
    minWidth: 0
  };

  return (
    <Box sx={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Box sx={{ minWidth: 300 }}>
        <Box
          sx={{
            ...rowSx,
            py: 0.75,
            borderBottom: '2px solid',
            borderColor: 'primary.500',
            bgcolor: 'background.level1'
          }}
        >
          {columns.map((col) => (
            <Typography
              key={col.label}
              level="body-xs"
              sx={{
                fontWeight: 700,
                textAlign: col.align || 'left',
                color: 'primary.500',
                lineHeight: 1.2
              }}
            >
              {col.label}
            </Typography>
          ))}
        </Box>
        {rows.map((row, idx) => (
          <Box
            key={getRowKey(row, idx)}
            sx={{
              ...rowSx,
              py: 0.875,
              borderBottom: '1px solid',
              borderColor: 'divider',
              '&:nth-of-type(even)': { bgcolor: 'background.level1' }
            }}
          >
            {columns.map((col) => (
              <Typography
                key={col.label}
                level="body-xs"
                sx={{
                  textAlign: col.align || 'left',
                  fontWeight: col.emphasize ? 600 : 400,
                  lineHeight: 1.25,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {col.render(row)}
              </Typography>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ReportMobileRowList;
